import React from 'react';
import styles from './PaginationDots.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const PaginationDots = ({
  length,
  current,
  backgroundColor = 'FFFFFF',
  borderColor = 'FFFFFF',
  isAbsolute = false,
  OS
}) => {
  let androidStyle = null;
  if (OS && OS !== 'iOS') {
    androidStyle = {marginBottom: '6px'};
  }
  const PageListItem = [...new Array(length)].map((_, index) => {
    const active = index === current;
    return (
      <li key={index} className={cx('PaginationDots__dot')}
          style={active ? {backgroundColor: `#${backgroundColor}`} : {border: `1px solid #${borderColor}`}}
      />
    )
  });

  return (
    <ul style={androidStyle} className={cx('PaginationDots', (isAbsolute && 'PaginationDots--absolute'))}>
      {PageListItem}
    </ul>
  );
};

export default PaginationDots;


// WEBPACK FOOTER //
// ./src/app/intro/components/PaginationDots/PaginationDots.js